import { smb_fetch, getAgpAgmsApiUrl } from '@/api/operator/fetch';

export const getAgreementList = (data: Record<string, any> = {}) => {
  const url = getAgpAgmsApiUrl('agency/agreement', 'get');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, false, false);
};

export const getAgreementListBatch = (data: Record<string, any> = {}) => {
  const url = getAgpAgmsApiUrl('agency/agreement', 'batch_get');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, false, false);
};

export const confirmAgreement = (data: Record<string, any>) => {
  const url = getAgpAgmsApiUrl('agency/agreement', 'confirm');
  return smb_fetch(url, {
    method: 'POST',
    contentType: 'application/json',
    data,
  }, false, false);
};
